var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.3,0.709992803 C13.1131685,0.522740129 12.8595176,0.417507197 12.595,0.417507197 C12.3304824,0.417507197 12.0768315,0.522740129 11.89,0.709992803 L7,5.5899928 L2.11,0.699992803 C1.92316847,0.512740129 1.66951764,0.407507197 1.405,0.407507197 C1.14048236,0.407507197 0.886831526,0.512740129 0.7,0.699992803 C0.31,1.0899928 0.31,1.7199928 0.7,2.1099928 L5.59,6.9999928 L0.7,11.8899928 C0.31,12.2799928 0.31,12.9099928 0.7,13.2999928 C1.09,13.6899928 1.72,13.6899928 2.11,13.2999928 L7,8.4099928 L11.89,13.2999928 C12.28,13.6899928 12.91,13.6899928 13.3,13.2999928 C13.69,12.9099928 13.69,12.2799928 13.3,11.8899928 L8.41,6.9999928 L13.3,2.1099928 C13.68,1.7299928 13.68,1.0899928 13.3,0.709992803 Z",
    id: "path-1-close"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP---02.1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02-01-0-Edit-Text-Doc",
    transform: "translate(-807.000000, -53.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(222.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(585.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2-close",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1-close"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/navigation/close_24px",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Color",
    mask: "url(#mask-2-close)",
    fill: "#022047"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.000000, -5.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 24 0 24 24 0 24"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e72c6c17.svg";
export { ForwardRef as ReactComponent };